export var getTime = function () {
    var now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};
export var getHoursMinutesFromTime = function (time) {
    if (Number.isNaN(time))
        return '';
    var sign = time < 0 ? '-' : '';
    var value = Math.abs(time);
    var h = Math.floor(value / 60);
    var m = value % 60;
    return "".concat(sign).concat(h, ":").concat(m < 10 ? '0' : '').concat(m);
};
